import React from 'react';

const About = () => (
  <main>
    <section>
      <h2 style={{ marginTop: '5rem', textAlign: 'center' }}>
        The About page is Under Construction
      </h2>
    </section>
  </main>
);

export default About;
